export default {"src":"/_next/static/media/reject.31badc72.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};